import { useAccordionState } from './AccordionContext'

export function useIsExpanded(accordion: string) {
  const state = useAccordionState()

  return state.expanded.includes(accordion)
}
